export const template = {
	id: 'title',
	name: 'title',
	desription: 'description',
	price: '0',
	img: '',
	brandId: 'brand',
	comments: ''
};